export default "__VITE_ASSET__CZo_KsEN__"